import { SubmissionObject } from 'src/pages/submissions/script/common.data'
export default {
  formatPrice (value) {
    const price = parseFloat(value)
    return !isNaN(price) ? '$ ' + price.toFixed(2) : '&mdash;'
  },
  selectedFormats (collection) {
    const format = []
    collection.map((value) => {
      const val = this.isFormatAvailable(value)
      val.map(o => o.formatId).indexOf(7)
      let id = val.map(o => o.formatId).indexOf(7)
      if (id === -1) {
        id = val.map(o => o.formatId).indexOf(11)
        if (id === -1) {
          id = 0
        }
      }
      format.push(val[id].formatId)
    })
    return format
  },
  isFormatAvailable (data) {
    if (data.hasOwnProperty('formats') && data.formats.length > 0) {
      return data.formats
    }
    if (!data.hasOwnProperty('formats') || data.formats.length === 0) {
      return [{ formatId: null, name: 'Not Available' }]
    }
  },
  showReview (formtId, submissionId) {
    this.$store.commit('submissions/setFormat', formtId)
    const obj = {
      name: 'released_submissions_details',
      params: {
        id: submissionId,
        format: formtId === null ? 0 : formtId
      }
    }
    this.$store
      .dispatch('submissions/reset')
      .then(() => {
        this.$store.commit('binaries/clear')
        this.$store.commit('designers/clear')
        this.$store.commit('graphics/clear')
        this.$store.commit('tags/clear')
        SubmissionObject.reset()
      })
      .then(() => {
        this.$router.push(obj)
      })
  },
  loadPageStart () {
    this.loadActive = true
    this.scrollPagination.loading()
  },
  loadPageComplete (results) {
    const len = results.collection.length
    if (len > 0) {
      this.scrollPagination.idle()
      this.scrollEnd = false
    }
    this.loadActive = false
  },
  processPagination (component, results, callNextPage = this.loadNextPage) {
    const result = component === 'promos-list' ? results.promotions : results.collection
    if (result.length > 0) {
      const context = typeof this.$el.querySelector === 'function'
        ? this.$el.querySelector(`#${this.$vId(this, component)}`)
        : null
      this.scrollPagination.set({
        state: 'idle',
        onDocEnd: callNextPage,
        onBottom: (bool) => {
          this.scrollEnd = bool;
        },
        detectMargin: 200,
        context
      });
    this.loadPageComplete(results)
  }
}
}
